import { React, useState, useEffect } from 'react';
import Nav from './nav';
import './tabs.css';
import Card from './card';
import Transcript from './bulletin';
import { Form, useNavigate } from 'react-router-dom';

function Tab() {
  const [activeTab, setActiveTab] = useState('Tab1');
  const navigate = useNavigate();

  useEffect(() => {
    switch (activeTab) {
      case 'Tab1':
        document.title = 'UNIKAL';
        break;
      case 'Tab2':
        document.title = 'Bulletin Academique';
        break;
      case 'Tab3':
        document.title = 'Reçu de Paiement';
        break;
      default:
        document.title = 'Admin';
    }
  }, [activeTab]);

  const enter = () => {
    navigate('/gen')
}
  return (
    <div className="KAL"> {/* title */}
      <div className="tab-page">
        <Nav/>
        <br/>
        <br/>
        <div className="tab-container">
          <div className="tabs">
            <button
              className={activeTab === 'Tab1' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab1')}
            >
              Carte Etudiant
            </button>
            <button
              className={activeTab === 'Tab2' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab2')}
            >
              Bulletin Academique
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'Tab1' && <div className="content"><Card/></div>}
            {activeTab === 'Tab2' && <div className="content"><Transcript/></div>}
          </div>
        </div>
        <footer>UNIKAL © All Rights Reserved.</footer>
      </div>
    </div>
    );
}

export default Tab;
